import moment from "moment";
export const date = (value, format) => {
    if (!value) return "";
    return moment(value).format(format);
};
